import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import JSBridgeApi from '../../lib/JSBridge';
// import '../../../../../mock/hybridApp';
import http from '@/services/http';
import disablePageScaling from '@/utils/disablePageScaling';

function AppLayout() {
  disablePageScaling();
  const [appToken, setAppToken] = useState('');
  if (window.JSBridgeModel) {
    JSBridgeApi.use(window.JSBridgeModel);
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');
    if (token) {
      setAppToken(token);
      http.setToken(token, '', '');
    }
  }, []);

  return appToken && <Outlet />;
}

export default AppLayout;
